import React from "react";
import { Anchor, Text, NameValuePair } from "grommet";

const SharepointValuePair = ({ url }) => (
  <NameValuePair name="Fichiers">
    <SharepointUrl url={url} />
  </NameValuePair>
);

const SharepointUrl = ({ url }) => (
  <Text color="text-strong">
    {url ? (
      <Anchor href={url} target="_blank">
        Ouvrir le Sharepoint
      </Anchor>
    ) : (
      <div>Il n'y a pas de dossier Sharepoint associé</div>
    )}
  </Text>
);

export { SharepointValuePair, SharepointUrl };
